import axios from 'axios';
import store from '../redux/store';
import { StatusEnum } from '../models/CMS';

function getUTCOffsetMs(date: Date, timezone: string): number {
    const parts = new Intl.DateTimeFormat('en-US', {
        timeZone: timezone,
        year: 'numeric', month: '2-digit', day: '2-digit',
        hour: '2-digit', minute: '2-digit', second: '2-digit',
        hour12: false,
    }).formatToParts(date);
    const get = (type: string) => parseInt(parts.find(p => p.type === type)?.value ?? '0', 10);
    const local = new Date(Date.UTC(get('year'), get('month') - 1, get('day'), get('hour') % 24, get('minute'), get('second')));
    return local.getTime() - date.getTime();
}

function localStringToUTC(localStr: string, timezone: string): Date {
    const roughUTC = new Date(localStr + 'Z');
    return new Date(roughUTC.getTime() - getUTCOffsetMs(roughUTC, timezone));
}

function findBannerData(rows: any[]): any | null {
    for (const row of rows) {
        for (const cell of row.cells ?? []) {
            if (cell.plugin?.id === 'siteMaintenanceBannerPlugin') {
                return cell.dataI18n?.default ?? null;
            }
            const nested = findBannerData(cell.rows ?? []);
            if (nested) return nested;
        }
    }
    return null;
}

export async function checkMaintenanceActive(landingContentId: string): Promise<boolean> {
    try {
        const { baseApiUrl, bearerToken } = store.getState().webAppSettings;
        const { data } = await axios.get(
            `${baseApiUrl}/MSB_CMS/api/v1/Contents/${landingContentId}`,
            { headers: { Authorization: `Bearer ${bearerToken}` } }
        );

        const revision = data.revisions?.find((r: any) => r.statusEnum === StatusEnum.Draft);
        if (!revision) return false;

        const bannerData = findBannerData(JSON.parse(revision.value)?.rows ?? []);
        if (!bannerData) return false;

        const { isEnabled, startDateTime, endDateTime, selectedTimezone = 'America/Chicago' } = bannerData;

        if (startDateTime && endDateTime) {
            const now = new Date();
            const start = localStringToUTC(startDateTime, selectedTimezone);
            const end = localStringToUTC(endDateTime, selectedTimezone);
            return now >= start && now <= end;
        }

        return isEnabled === true || isEnabled === 'true';
    } catch {
        return false;
    }
}
